import React from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import truncate from 'lodash/truncate'
import numeral from 'numeral'
dayjs.extend(utc)

export const mapFormDefaultValues = (asset) => {
  return {
    longName: asset.longName
  }
}

export const levelDatesQuery = { levelType: 'user' }

const cellTemplates = {
  date: ({ value }) => value ? dayjs.utc(value).format('M/D/YYYY') : '',
  money: ({ value }) => <span style={{ display: 'block', padding: '0 5px', width: '100%', textAlign: 'right' }}>{numeral(value).format('0,0.00')}</span>
}

const MAX_CHARACTERS = 30
const CHARACTER_SEPARATOR = ' '

const accountNumberAccesor = (row) =>
  row.accountNumber || row.displayNumber || row.longNumber || row.shortNumber

export const defaultColumnConfig = {
  columns: [
    { Header: 'Account Number', accessor: accountNumberAccesor, id: 'longNumber', disableSortBy: true },
    { Header: 'Account Name', accessor: (row) => truncate(row.displayName || row.longName || row.accountLongName, { length: MAX_CHARACTERS, separator: CHARACTER_SEPARATOR }), id: 'displayName', disableSortBy: true },
    { Header: 'Value', accessor: 'endingValue', id: 'endingValue', Cell: cellTemplates.money, disableSortBy: true, alignRight: true },
    { Header: 'Units', accessor: 'units', id: 'units', disableSortBy: true, alignRight: true }
  ],
  defaultSort: [
    { id: 'longName', desc: false }
  ]
}
